<h3 mat-dialog-title class="title">{{ data.title }}</h3>

<mat-dialog-content>
  <div class="name-input-section" *ngIf="data.showNameInput">
    <mat-form-field class="name-field">
      <mat-label>{{ data.nameLabel || ('catalog.rules.ruleName' | translate) }}</mat-label>
      <input matInput type="text" [(ngModel)]="newItemName" required>
    </mat-form-field>
  </div>

  <div class="copy-elements-section">
    <h4 class="section-title">{{ 'catalog.product.copy.selectElements' | translate }}</h4>

    <div class="elements-list">
      <div *ngFor="let element of selectedElements" class="element-item">
        <mat-checkbox
          [checked]="element.checked"
          [disabled]="element.disabled"
          (change)="onElementChange(element.id, $event.checked)"
          class="element-checkbox">
          <span class="element-name">{{ element.name }}</span>
        </mat-checkbox>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <txp-button
    (click)="handleCancel()"
    data-qa-label="CancelButton"
    [style]="buttonStyle.SECONDARY">
    {{ data.cancelText }}
  </txp-button>
  <txp-button
    data-qa-label="CopyButton"
    [style]="buttonStyle.PRIMARY"
    [disabled]="data.showNameInput && !(newItemName && newItemName.trim())"
    (click)="handleCopy()">
    {{ data.confirmText }}
  </txp-button>
</mat-dialog-actions>
